// extracted by mini-css-extract-plugin
export var statItem = "_dv-1";
export var statsRow = "_dv-0";